import React, { useState, useEffect, useRef } from "react";
import Header from "../../Components/Header/header";
import { useNavigate } from "react-router-dom";
import { FaFilter, FaSearch } from "react-icons/fa";
import { FaTimes, FaUpload, FaEdit, FaEye, FaTrash, FaFileExcel, FaPlus, FaCopy } from "react-icons/fa";
import jsPDF from "jspdf";
import Footer from "../../Components/Footer/footer";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import html2canvas from "html2canvas";
import "./initialsetup.css";

const InitialSetup = () => {
  const [schemes, setSchemes] = useState([]);
  const [policyTypes, setPolicyTypes] = useState([]);
  const [policies, setPolicies] = useState([]);
  const [filteredPolicies, setFilteredPolicies] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [showEmployeePopup, setShowEmployeePopup] = useState(false);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [designationList, setDesignationList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [loadingEmployeeList, setLoadingEmployeeList] = useState(true);
  const [categories, setCategories] = useState([]);
  const [currentScheme, setCurrentScheme] = useState(null); // scheme object when + clicked
  const [premiumRates, setPremiumRates] = useState([]); // rates for current policy
  const [selectedEmployeePremiums, setSelectedEmployeePremiums] = useState({}); // map empId -> { premium, gstAmount, total }
  const [showChoicePopup, setShowChoicePopup] = useState(false);
  const [selectedScheme, setSelectedScheme] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [schemeList, setSchemeList] = useState([]);
  const [loadingSchemes, setLoadingSchemes] = useState(false);
  const [selectedDesignation, setSelectedDesignation] = useState("");
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [popupCategory, setPopupCategory] = useState("");
  const [filterCategory, setFilterCategory] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const [showMailPopup, setShowMailPopup] = useState(false);
  const [insuranceCompanies, setInsuranceCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);
  const [showWithoutInsurerPopup, setShowWithoutInsurerPopup] = useState(false);
  const [selectedSumInsured, setSelectedSumInsured] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [isViewing, setIsViewing] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [showEmployeesTable, setShowEmployeesTable] = useState(false);
  const [viewSchemeEmployees, setViewSchemeEmployees] = useState([]);
  const [schemeError, setSchemeError] = useState("");
  const [editPolicyId, setEditPolicyId] = useState(null);
  const tableRef = useRef();
  const recordsPerPage = 15;
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentEmployees = filteredEmployees.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(filteredEmployees.length / recordsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const [status, setStatus] = useState("idle");
  const [newSchemeWithout, setNewSchemeWithout] = useState({
    schemeName: "",
    startDate: "",
    endDate: "",
    familyDefinition: [], // array of strings e.g. ["Spouse","Child"]
    noOfChildren: 0,
    schemeDoc: null,
    gst: null,
    premium: null,
  });

  const navigate = useNavigate();

  const [newScheme, setNewScheme] = useState({
    policyType: "",
    policyId: "",
    tpa: "",
    insurer: "",
    policyNumber: "",
    schemeName: "",
    gst: "",
    startDate: "",
    endDate: "",
    familyDefinition: [],
    premium: "",
    gst1: "",
    totalPremium: "",
    schemeDoc: null,
    noOfChildren: "",
    sumInsured: "",
  });


  const toggleFamilyWithout = (value) => {
    setNewSchemeWithout((prev) => {
      const fd = prev.familyDefinition || [];
      if (fd.includes(value)) {
        return { ...prev, familyDefinition: fd.filter((x) => x !== value) };
      }
      return { ...prev, familyDefinition: [...fd, value] };
    });
  };


  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (e) {
        console.error("Error parsing user:", e);
      }
    }
  }, []);

  // 


  const fetchCategoriesByOrg = async () => {
    const orgId = localStorage.getItem("org_id");
    if (!orgId) {
      console.error("Organization ID not found in localStorage");
      return;
    }

    try {
      const res = await fetch(`/api/categories/org/${orgId}`);
      const data = await res.json();

      if (data.success) {
        const uniqueCategories = [
          ...new Map(
            data.rows.map(item => [item.cat_org_custom_name, item])
          ).values()
        ];

        setCategories(uniqueCategories);
      } else {
        console.error("Failed to fetch categories:", data.message);
      }
    } catch (err) {
      console.error("Error fetching categories:", err);
    }
  };


  useEffect(() => {
    fetchCategoriesByOrg();
  }, []);



  useEffect(() => {
    fetch("/api/insurance_companies")
      .then((res) => res.json())
      .then((data) => setInsuranceCompanies(Array.isArray(data) ? data : []))
      .catch((err) => console.error("fetch insurance error:", err));
  }, []);



  useEffect(() => {
    if (showEmployeePopup && selectedScheme) {
      fetch(`?policy_id=${selectedScheme.policy_id}`)
        .then(res => res.json())
        .then(data => {
          console.log("Fetched premium rates:", data);
          setPremiumRates(data);
        })
        .catch(err => console.error("Failed to load premium rates", err));
    }
  }, [showEmployeePopup, selectedScheme]);

  const handleViewEmployees = (scheme_id, cat_id) => {
    const scheme = schemeList.find(s => s.scheme_id === scheme_id && s.cat_id === cat_id);
    if (!scheme) return alert("Scheme not found");

    setSelectedScheme(scheme);

    const filteredEmployees = employeeList.filter(
      emp => emp.scheme_id === scheme_id && emp.cat_id === cat_id
    );

    if (filteredEmployees.length === 0) {
      alert("No employees found for this scheme");
    }

    setViewSchemeEmployees(filteredEmployees);
    setShowEmployeesTable(true);
  };

  const fetchSchemesByCategory = async (catId) => {
    const orgId = localStorage.getItem("org_id");
    if (!catId || !orgId) return;
    setLoadingSchemes(true);
    try {
      const res = await fetch(`/api/schemes/${catId}?org_id=${orgId}`);
      const data = await res.json();
      if (data.success) setSchemeList(data.rows);
      else console.error("Failed to fetch schemes:", data.message);
    } catch (err) {
      console.error("Error fetching schemes:", err);
    } finally {
      setLoadingSchemes(false);
    }
  };

  const fetchSchemes = async () => {
    try {
      const org_id = localStorage.getItem("org_id"); // ✅ get org_id of logged-in user
      const res = await fetch(`/api/setup/getAll?org_id=${org_id}`);
      const data = await res.json();
      if (data.success && Array.isArray(data.rows)) {
        setSchemes(data.rows);
        setSchemeList(data.rows); // important
      }
    } catch (err) {
      console.error("Error fetching schemes:", err);
    }
  };

  useEffect(() => {
    const fetchEmployeeList = async () => {
      try {
        const userOrgId = JSON.parse(localStorage.getItem("user"))?.org_id;

        const res = await fetch(
          `/api/employee-list?org_id=${userOrgId}`
        );
        const data = await res.json();

        setEmployeeList(data);
      } catch (err) {
        console.error("Error fetching employee list:", err);
      } finally {
        setLoadingEmployeeList(false);
      }
    };

    fetchEmployeeList();
  }, []);


  const fetchDesignationList = async () => {
    try {
      const res = await fetch("/api/designation-list");
      const data = await res.json();
      setDesignationList(data || []);
    } catch (err) {
      console.error("Error fetching designations:", err);
    }
  };

  useEffect(() => {
    fetchSchemes();
    fetchPolicyTypes();
    fetchPolicies();
   
    fetchDesignationList();
  }, []);

  useEffect(() => {
    fetchEmployees();
  }, []);

  const fetchEmployees = async () => {
    try {
      setLoadingEmployeeList(true);
      const res = await fetch("/api/employee-list");
      const data = await res.json();

      if (Array.isArray(data)) {
        setEmployeeList(data);
        const uniqueDesignations = [
          ...new Set(
            data
              .map(
                (emp) =>
                  emp.designation || emp.emp_designation || emp.emp_designation_name
              )
              .filter(Boolean)
          ),
        ];

        setDesignationList(uniqueDesignations);
        setFilteredEmployees(data);
      }
    } catch (error) {
      console.error("Error fetching employees:", error);
    } finally {
      setLoadingEmployeeList(false);
    }
  };

  // 🔹 When a designation is selected, filter employees
  useEffect(() => {
    if (selectedDesignation) {
      const filtered = employeeList.filter(
        (emp) =>
          emp.designation === selectedDesignation ||
          emp.emp_designation === selectedDesignation ||
          emp.emp_designation_name === selectedDesignation
      );
      setFilteredEmployees(filtered);
    } else {
      setFilteredEmployees(employeeList);
    }
  }, [selectedDesignation, employeeList]);

  useEffect(() => {
  const premium = parseFloat(newSchemeWithout.premium || 0);
  const gst = parseFloat(newSchemeWithout.gst || 0);

  if (premium && gst >= 0) {
    const total = premium + (premium * gst / 100);

    setNewSchemeWithout((prev) => ({
      ...prev,
      totalPremium: total.toFixed(2),
    }));
  } else {
    setNewSchemeWithout((prev) => ({
      ...prev,
      totalPremium: "",
    }));
  }
}, [newSchemeWithout.premium, newSchemeWithout.gst]);

  // Fetch policy types
  const fetchPolicyTypes = async () => {
    try {
      const res = await fetch("/api/setup/policyTypes");
      const data = await res.json();
      setPolicyTypes(data.rows || []);
    } catch (err) {
      console.error("Error fetching policy types:", err);
    }
  };

  // Fetch all policies
  const fetchPolicies = async () => {
    try {
      const userOrgId = JSON.parse(localStorage.getItem("user"))?.org_id;

      const res = await fetch(`/api/setup/policies?org_id=${userOrgId}`);
      const data = await res.json();
      setPolicies(data.rows || []);
    } catch (err) {
      console.error("Error fetching policies:", err);
    }
  };


  useEffect(() => {
    fetchSchemes();
    fetchPolicyTypes();
    fetchPolicies();
  }, []);

  const handleAddSchemeClick = () => {
    setShowChoicePopup(true);
    setNewScheme({});
  };

  const chooseWithInsurer = () => {
    setShowChoicePopup(false);
    setShowPopup(true); // your existing popup (do not modify)
  };

  const chooseWithoutInsurer = () => {
    setShowChoicePopup(false);
    setShowWithoutInsurerPopup(true);
  };

  const handleWithoutFile = (e) => {
    const file = e.target.files[0];
    setNewSchemeWithout((prev) => ({ ...prev, schemeDoc: file }));
  };


  useEffect(() => {
    if (newScheme.policyId) {
      fetch(`/api/premiumRates?policy_id=${newScheme.policyId}`)
        .then((res) => res.json())
        .then((data) => {
          console.log("Fetched premium rates for policy:", newScheme.policyId, data);
          setPremiumRates(data);
        })
        .catch((err) => console.error("Failed to load premium rates", err));
    } else {
      setPremiumRates([]); // reset when no policy selected
    }
  }, [newScheme.policyId]);


  


  // Submit without-insurer form
  const handleSaveWithoutInsurer = async (e) => {
  e.preventDefault();

  try {
    const storedUser = JSON.parse(localStorage.getItem("user"));

    if (!newSchemeWithout.cat_id) {
      alert("Please select category");
      return;
    }

    const formData = new FormData();

    formData.append("org_id", storedUser?.org_id);
    formData.append("cat_id", newSchemeWithout.cat_id);

    formData.append("scheme_name", newSchemeWithout.schemeName);
    formData.append("start_date", newSchemeWithout.startDate);
    formData.append("end_date", newSchemeWithout.endDate);

    formData.append("premium", newSchemeWithout.premium || "");
    formData.append("gst", newSchemeWithout.gst || "");
    formData.append("total_premium", newSchemeWithout.totalPremium || "");

    formData.append(
      "family_spouse",
      newSchemeWithout.familyDefinition.includes("Spouse") ? "1" : "0"
    );
    formData.append(
      "family_child",
      newSchemeWithout.familyDefinition.includes("Child") ? "1" : "0"
    );
    formData.append(
      "family_parents",
      newSchemeWithout.familyDefinition.includes("Parents") ? "1" : "0"
    );
    formData.append(
      "family_inlaws",
      newSchemeWithout.familyDefinition.includes("In-LawsParents") ? "1" : "0"
    );

    formData.append("no_of_children", newSchemeWithout.noOfChildren || 0);

    if (newSchemeWithout.schemeDoc) {
      formData.append("scheme_doc", newSchemeWithout.schemeDoc);
    }

    const url = isEditing
      ? `/api/scheme/updateWithoutInsurer/${newSchemeWithout.schemeId}`
      : `/api/scheme/createWithoutInsurer`;

    const method = isEditing ? "PUT" : "POST";

    const res = await fetch(url, { method, body: formData });
    const data = await res.json();

    if (data.success) {
      alert(isEditing ? "Updated successfully!" : "Created successfully!");
      setShowWithoutInsurerPopup(false);
      setIsEditing(false);
      fetchSchemes();
    } else {
      alert(data.message);
    }
  } catch (err) {
    console.error(err);
    alert("Error saving scheme");
  }
};

  const handleDownloadExcel = () => {
    if (!tableRef.current) return;

    // Create a workbook
    const wb = XLSX.utils.book_new();

    // Convert HTML table to worksheet
    const ws = XLSX.utils.table_to_sheet(tableRef.current);

    // Append worksheet to workbook
    XLSX.utils.book_append_sheet(wb, ws, "Employees");

    // Generate Excel file and download
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `Employees_${selectedScheme?.scheme_name || "N/A"}.xlsx`);
  };



  const handleChange = (e) => {
    const { name, value } = e.target;

    setNewScheme((prev) => ({ ...prev, [name]: value }));

    // If Policy Type changes, filter policies
    if (name === "policyType") {
      const filtered = policies.filter(
        (p) => p.policy_type_id.toString() === value
      );
      setFilteredPolicies(filtered);

      // Reset dependent fields when policy type changes
      setNewScheme((prev) => ({
        ...prev,
        policyId: "",
        tpa: "",
        insurer: "",
        policyNumber: "",
        startDate: "",
        endDate: "",
        gstPercent: "",
      }));
    }


    // When Policy Name changes, auto-fill related fields
    if (name === "policyId") {
      const selectedPolicy = policies.find(
        (p) => p.policy_id.toString() === value
      );
      if (selectedPolicy) {
        setNewScheme((prev) => ({
          ...prev,
          tpa: selectedPolicy.tpa_name || "",
          insurer: selectedPolicy.company_name || "",
          policyNumber: selectedPolicy.policy_number || "",
          startDate: selectedPolicy.start_date
            ? selectedPolicy.start_date.split("T")[0]
            : "",
          endDate: selectedPolicy.end_date
            ? selectedPolicy.end_date.split("T")[0]
            : "",
          gst: selectedPolicy.gst_percent || "",
        }));
      }
    }

  };
  const handleCheckbox = (e) => {
    const { value, checked } = e.target;

    setNewScheme((prev) => {
      let updatedFamilyDef = checked
        ? [...(prev.familyDefinition || []), value]
        : (prev.familyDefinition || []).filter((item) => item !== value);

      // Reset child count if "Child" is unchecked
      const isChildSelected = updatedFamilyDef.includes("Child");

      return {
        ...prev,
        familyDefinition: updatedFamilyDef,
        family_spouse: updatedFamilyDef.includes("Spouse"),
        family_child: isChildSelected,
        family_parents: updatedFamilyDef.includes("Parents"),
        family_inlaws: updatedFamilyDef.includes("In-LawsParents"),
        no_of_children: isChildSelected ? prev.no_of_children || "" : "", // reset when unselected
      };
    });
  };

  const handleDelete = async (scheme_id) => {
    if (!window.confirm("Are you sure you want to delete this scheme?")) return;

    try {
      const response = await fetch(`/api/schemes/${scheme_id}`, {
        method: "DELETE",
      });

      if (response.ok) {
        alert("Scheme deleted successfully!");
        // Refresh list
        setSchemes((prev) => prev.filter((s) => s.scheme_id !== scheme_id));
      } else {
        alert("Failed to delete scheme.");
      }
    } catch (err) {
      console.error("Error deleting scheme:", err);
      alert("Error deleting scheme.");
    }
  };

  const parseAgeFromDob = (dobStr) => {
    if (!dobStr) return 0;
    const dob = new Date(dobStr);
    const now = new Date();
    const age = Math.floor((now - dob) / (365.25 * 24 * 60 * 60 * 1000));
    return age;
  };



  const findBasePremiumByAge = (age, rates, sumInsured) => {
    if (!Array.isArray(rates)) return 0;

    const numericSumInsured = Number(sumInsured) || 0;

    let matchedRate = null;

    for (const r of rates) {
      if (!r.age_range) continue;

      const [minAge, maxAge] = r.age_range.split("-").map(n => parseInt(n, 10));
      const matchesAge = age >= (minAge || 0) && age <= (maxAge || 200);

      const matchesSumInsured = Number(r.sum_insured) === numericSumInsured;

      if (matchesAge && matchesSumInsured) {
        matchedRate = r;
        break;
      }
    }

    if (!matchedRate) {
      const sorted = [...rates].sort((a, b) => Number(a.sum_insured) - Number(b.sum_insured));
      matchedRate = sorted[sorted.length - 1] || {};
    }

    return Number(matchedRate.base_premium || 0);
  };


  const computeProrateFactor = (joinDateStr, schemeStartStr, schemeEndStr) => {
    const start = schemeStartStr ? new Date(schemeStartStr) : null;
    const end = schemeEndStr ? new Date(schemeEndStr) : null;
    const join = joinDateStr ? new Date(joinDateStr) : null;

    if (!start || !end) return 1;

    const policyDays = Math.max(1, (end - start) / (1000 * 60 * 60 * 24));
    let activeDays;
    if (!join || join <= start) {
      activeDays = policyDays;
    } else if (join > end) {
      activeDays = 0;
    } else {
      activeDays = (end - join) / (1000 * 60 * 60 * 24);
    }

    const factor = Math.max(0, Math.min(1, activeDays / policyDays));
    return factor;
  };

  const computePremiumForEmployee = (emp, scheme, rates) => {
    if (!scheme || Object.keys(scheme).length === 0) {
      return { premium: 0, gstAmount: 0, total: 0 };
    }

    const validSumInsured = Number(scheme.sum_insured || 0);
    const gstPercent = Number(scheme.gst || 0);
    const round = (v) => Math.round((v + Number.EPSILON) * 100) / 100;

    let totalBase = 0;

    // EMPLOYEE PREMIUM
    totalBase += findBasePremiumByAge(parseAgeFromDob(emp.dob), rates, validSumInsured);

    // SPOUSE
    if (scheme.family_spouse && emp.spouse_dob) {
      totalBase += findBasePremiumByAge(
        parseAgeFromDob(emp.spouse_dob),
        rates,
        validSumInsured
      );
    }

    // CHILDREN
    if (scheme.family_child) {
      const allowed = Number(scheme.no_of_children) || 0;

      // Safe handling: child_dob is always array
      const childDobs = Array.isArray(emp.child_dob)
        ? emp.child_dob
        : (emp.child_dob ? [emp.child_dob] : []);

      for (let i = 0; i < Math.min(childDobs.length, allowed); i++) {
        totalBase += findBasePremiumByAge(
          parseAgeFromDob(childDobs[i]),
          rates,
          validSumInsured
        );
      }
    }

    // PARENTS
    if (scheme.family_parents) {
      if (emp.father_dob)
        totalBase += findBasePremiumByAge(parseAgeFromDob(emp.father_dob), rates, validSumInsured);

      if (emp.mother_dob)
        totalBase += findBasePremiumByAge(parseAgeFromDob(emp.mother_dob), rates, validSumInsured);
    }

    // IN-LAWS
    if (scheme.family_inlaws) {
      if (emp.father_inlaw_dob)
        totalBase += findBasePremiumByAge(parseAgeFromDob(emp.father_inlaw_dob), rates, validSumInsured);

      if (emp.mother_inlaw_dob)
        totalBase += findBasePremiumByAge(parseAgeFromDob(emp.mother_inlaw_dob), rates, validSumInsured);
    }

    // GST & TOTAL
    const gstAmount = round((totalBase * gstPercent) / 100);
    const total = round(totalBase + gstAmount);

    return {
      premium: round(totalBase),
      gstAmount,
      total,
    };
  };

  const handleSelectAllEmployees = (e) => {
    if (e.target.checked) {
      setSelectedEmployees(filteredEmployees.map(emp => emp.id));
    } else {
      setSelectedEmployees([]);
    }
  };

  const openAddEmployeePopup = (scheme) => {
    setSelectedScheme(scheme);
    setShowEmployeePopup(true);
  };

  const handleView = async (scheme) => {
    // 👉 CASE 1: SCHEME CREATED WITHOUT INSURER — open the correct popup
    if (!scheme.insurer && !scheme.policy_id) {
      setNewSchemeWithout({
        schemeId: scheme.scheme_id,
        schemeName: scheme.scheme_name,
        startDate: scheme.start_date?.split("T")[0],
        endDate: scheme.end_date?.split("T")[0],
        gst: scheme.gst,
        premium: scheme.premium,
        familyDefinition: [
          scheme.family_spouse ? "Spouse" : null,
          scheme.family_child ? "Child" : null,
          scheme.family_parents ? "Parents" : null,
          scheme.family_inlaws ? "In-LawsParents" : null,
        ].filter(Boolean),
        noOfChildren: scheme.no_of_children || 0,
      });
      setIsEditing(false);
      setIsViewing(true);
      setShowWithoutInsurerPopup(true);
      return; // 🚨 STOP — prevent normal view popup
    }

    // 👉 CASE 2: NORMAL VIEW for schemes with insurer/policy
    setIsViewing(true);     // enable view mode
    setIsEditing(false);    // ensure edit mode is OFF

    setNewScheme({
      category: scheme.categories,
      policyType: scheme.policy_type_id,
      policyId: scheme.policy_id,
      policyNumber: scheme.policy_number,
      insurer: scheme.insurer,
      tpa: scheme.tpa,
      schemeName: scheme.scheme_name,
      gst: scheme.gst,
      startDate: scheme.start_date?.split("T")[0],
      endDate: scheme.end_date?.split("T")[0],
      familyDefinition: [
        scheme.family_spouse && "Spouse",
        scheme.family_child && "Child",
        scheme.family_parents && "Parents",
        scheme.family_inlaws && "In-LawsParents",
      ].filter(Boolean),
      no_of_children: scheme.no_of_children || 0,
      sum_insured: scheme.sum_insured,
      scheme_id: scheme.scheme_id,
    });

    // fetch premium rates
    const res = await fetch(`/api/premiumRates?policy_id=${scheme.policy_id}`);
    const data = await res.json();
    setPremiumRates(data);

    setSelectedCategory(scheme.categories);
    setSelectedSumInsured(scheme.sum_insured);

    setShowPopup(true);
  };

  // 1️⃣ Edit handler
  // const handleEdit = async (scheme) => {
  //   setIsEditing(true);
  //   setIsViewing(false);
  //   setShowPopup(true);

  //   setPopupCategory(scheme.cat_id);

  //   setNewScheme({
  //     scheme_id: scheme.scheme_id,
  //     cat_id: scheme.cat_id,  
  //     policyType: scheme.policy_type_id || "",
  //     policyId: "", // temp
  //     policyNumber: scheme.policy_number || "",
  //     insurer: scheme.insurer || "",
  //     tpa: scheme.tpa || "",
  //     gst: scheme.gst || "",
  //     startDate: scheme.start_date?.split("T")[0] || "",
  //     endDate: scheme.end_date?.split("T")[0] || "",
  //     schemeName: scheme.scheme_name || "",
  //     familyDefinition: [
  //       scheme.family_spouse && "Spouse",
  //       scheme.family_child && "Child",
  //       scheme.family_parents && "Parents",
  //       scheme.family_inlaws && "In-LawsParents",
  //     ].filter(Boolean),
  //     no_of_children: scheme.no_of_children || "",
  //     premium: scheme.premium || "",
  //     gst1: scheme.gst1 || "",
  //     totalPremium: scheme.total_premium || "",
  //     scheme_doc: null,
  //     policyName: scheme.policy_name || "",
      
  //   });

  //   // ✅ Fetch policies and default to empty array if undefined
  //   let policies = (await fetchSchemesByCategory(scheme.cat_id)) || [];

  //   // ✅ Ensure saved policy is included
  //   if (scheme.policy_id && !policies.some((p) => p.policy_id === scheme.policy_id)) {
  //     policies = [...policies, { policy_id: scheme.policy_id, policy_name: scheme.policy_name }];
  //   }
  //   setSelectedSumInsured(scheme.sum_insured);
  //   setFilteredPolicies(policies);
    

  //   // Set the policyId now
  //   setNewScheme((prev) => ({
  //     ...prev,
  //     policyId: scheme.policy_id,
  //   }));
  // };

const handleEdit = async (scheme) => {
  setIsEditing(true);
  setIsViewing(false);
  setShowPopup(true);

  const categoryId = scheme.cat_id?.toString();

  // ✅ Sync dropdown filter
  setFilterCategory(categoryId);

  // ✅ Sync popup category (if used separately)
  setPopupCategory(categoryId);

  // ✅ Set form values
  setNewScheme({
    scheme_id: scheme.scheme_id,
    cat_id: categoryId,
    policyType: scheme.policy_type_id || "",
    policyId: scheme.policy_id || "",
    policyNumber: scheme.policy_number || "",
    insurer: scheme.insurer || "",
    tpa: scheme.tpa || "",
    gst: scheme.gst || "",
    startDate: scheme.start_date?.split("T")[0] || "",
    endDate: scheme.end_date?.split("T")[0] || "",
    schemeName: scheme.scheme_name || "",
    familyDefinition: [
      scheme.family_spouse && "Spouse",
      scheme.family_child && "Child",
      scheme.family_parents && "Parents",
      scheme.family_inlaws && "In-LawsParents",
    ].filter(Boolean),
    no_of_children: scheme.no_of_children || "",
    premium: scheme.premium || "",
    gst1: scheme.gst1 || "",
    totalPremium: scheme.total_premium || "",
    scheme_doc: null,
    policyName: scheme.policy_name || "",
  });

  // ✅ Fetch policies for selected category
  let policies = (await fetchSchemesByCategory(categoryId)) || [];

  if (
    scheme.policy_id &&
    !policies.some((p) => p.policy_id?.toString() === scheme.policy_id?.toString())
  ) {
    policies.push({
      policy_id: scheme.policy_id,
      policy_name: scheme.policy_name,
    });
  }

  setSelectedSumInsured(scheme.sum_insured);
  setFilteredPolicies(policies);
};

  // 4️⃣ useEffect to fix timing (optional but safer)
  useEffect(() => {
    if (editPolicyId && filteredPolicies.length) {
      const match = filteredPolicies.find((p) => p.policy_id === editPolicyId);
      if (match) {
        setNewScheme((prev) => ({ ...prev, policyId: match.policy_id }));
        setEditPolicyId(null); // clear temporary
      }
    }
  }, [filteredPolicies, editPolicyId]);

  const handleEmployeeSelect = (empId) => {
    // Find the employee object
    const emp = employeeList.find(e => e.id === empId);
    if (!emp) return; // safety check

    // Toggle selection
    setSelectedEmployees(prev =>
      prev.includes(empId) ? prev.filter(id => id !== empId) : [...prev, empId]
    );

    // Compute premium
    const result = computePremiumForEmployee(emp, selectedScheme, premiumRates);

    // Update employeeList & filteredEmployees
    setEmployeeList(prev =>
      prev.map(e =>
        e.id === empId
          ? { ...e, checked: !e.checked, premium: result.premium, emp_gst: result.gstAmount, total_premium: result.total }
          : e
      )
    );

    setFilteredEmployees(prev =>
      prev.map(e =>
        e.id === empId
          ? { ...e, checked: !e.checked, premium: result.premium, emp_gst: result.gstAmount, total_premium: result.total }
          : e
      )
    );
  };

  const handleCategoryChange = (categoryName) => {
    setSelectedCategory(categoryName);

    // =======================
    // 1️⃣ Filter Employees (popup)
    // =======================
    if (categoryName) {
      const filtered = employeeList.filter(
        (emp) => emp.categories === categoryName
      );
      setFilteredEmployees(filtered);
    } else {
      setFilteredEmployees(employeeList); // show all employees
    }

    // Clear selected employees
    setSelectedEmployees([]);

    // =======================
    // 2️⃣ Filter Schemes (main table)
    // =======================
    if (!categoryName) {
      setSchemeList(schemes); // show all schemes again
      return;
    }

    // Load scheme list by category
    fetchSchemesByCategory(categoryName);
  };


  const handleAddEmployeesToScheme = async (schemeObj) => {
    try {
      setSelectedScheme(schemeObj);
      setShowEmployeePopup(true);

      // Fetch premium rates
      let rates = [];
      try {
        const prRes = await fetch(
          `/api/premiumRates?policy_id=${schemeObj.policy_id}&sum_insured=${schemeObj.sum_insured}`
        );
        const prData = await prRes.json();
        rates = Array.isArray(prData) ? prData : prData.rows || [];
        setPremiumRates(rates);
      } catch (err) {
        console.warn("Failed to fetch premiumRates", err);
        rates = [];
        setPremiumRates([]);
      }

      // Filter employees for this scheme category
      const filteredList = employeeList
        .filter((emp) => emp.cat_id === schemeObj.cat_id)
        .map((emp) => {

          // ✅ Combine all child DOBs into a single array
          const childDobs = [
            emp.child_dob,
            emp.child2_dob,
            emp.child3_dob
          ].filter(Boolean); // remove null/undefined

          const updatedEmp = {
            ...emp,
            child_dob: childDobs, // override child_dob for premium calculation
          };

          // Compute premium
          const computed = computePremiumForEmployee(updatedEmp, schemeObj, rates);

          return {
            ...updatedEmp,
            checked: true, // pre-select all employees
            premium: computed.premium,
            emp_gst: computed.gstAmount,
            total_premium: computed.total,
            scheme_id: schemeObj.scheme_id,
          };
        });

      setEmployeeList(filteredList);
      setFilteredEmployees(filteredList); // for table display
      setSelectedEmployees(filteredList.map((emp) => emp.id)); // mark all selected
    } catch (err) {
      console.error("Error adding employees to scheme:", err);
    }
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ Make sure familyDefinition is always an array
    const familyDefs = Array.isArray(newScheme.familyDefinition)
      ? newScheme.familyDefinition
      : [];

    // ✅ Only validate number of children if "Child" is selected
    if (familyDefs.includes("Child") && !newScheme.no_of_children) {
      alert("Please enter the number of children.");
      return;
    }

    try {
      const formData = new FormData();

      let policyNameToSend = "";
      if (newScheme.policyId) {
        const selected = filteredPolicies.find(
          (p) => String(p.policy_id) === String(newScheme.policyId)
        );
        policyNameToSend = selected?.policy_name || "";
      }

      formData.append("cat_id", newScheme.cat_id);
      formData.append("org_id", localStorage.getItem("org_id"));

      formData.append("policy_type_id", newScheme.policyType || null);
      formData.append("policy_id", newScheme.policyId || null);
      formData.append("policy_name", policyNameToSend);
      formData.append("policy_number", newScheme.policyNumber);
      formData.append("insurer", newScheme.insurer);
      formData.append("tpa", newScheme.tpa);
      formData.append("gst", newScheme.gst);
      formData.append("start_date", newScheme.startDate);
      formData.append("end_date", newScheme.endDate);
      formData.append("scheme_name", newScheme.schemeName);
      formData.append("family_spouse", familyDefs.includes("Spouse") ? 1 : 0);
      formData.append("family_child", familyDefs.includes("Child") ? 1 : 0);
      formData.append("family_parents", familyDefs.includes("Parents") ? 1 : 0);
      formData.append("family_inlaws", familyDefs.includes("In-LawsParents") ? 1 : 0);
      formData.append("no_of_children", newScheme.no_of_children || 0);
      formData.append("premium", newScheme.premium || null);
      formData.append("gst1", newScheme.gst1 || null);
      formData.append("total_premium", newScheme.totalPremium || null);
      formData.append("sum_insured", selectedSumInsured ? Number(selectedSumInsured) : null);
      if (newScheme.scheme_doc) {
        formData.append("scheme_doc", newScheme.scheme_doc);
      }

      const url = isEditing
        ? `/api/schemes/update/${newScheme.scheme_id}`
        : `/api/setup/addScheme`;

      const res = await fetch(url, {
        method: isEditing ? "PUT" : "POST",
        body: formData,
      });

      const data = await res.json();

      if (data.success) {
        alert(isEditing ? "Scheme updated successfully!" : "Scheme added successfully!");
        setShowPopup(false);
        setIsEditing(false);
        fetchSchemes(); // 🔁 refresh list
      } else {
        alert(data.message || "Save failed");
      }
    } catch (err) {
      console.error(err);
      alert("Error saving scheme");
    }
  };


  const handleSaveSelectedEmployees = async () => {
    try {
      if (selectedEmployees.length === 0) {
        alert("Please select at least one employee before saving.");
        return;
      }

      // 🔹 Use emp.id (not emp.emp_id) to filter selected employees
      const selectedData = filteredEmployees.filter((e) =>
        selectedEmployees.includes(e.id)
      );

      // 🔹 Calculate totals
      const totalPremium = selectedData.reduce(
        (sum, e) => sum + (parseFloat(e.premium) || 0),
        0
      );
      const totalGST = selectedData.reduce(
        (sum, e) => sum + (parseFloat(e.emp_gst) || 0),
        0
      );
      const totalWithGST = selectedData.reduce(
        (sum, e) => sum + (parseFloat(e.total_premium) || 0),
        0
      );

      // 🔹 Prepare payload (use emp_id for backend)
      const payload = {
        scheme_id: selectedScheme.scheme_id,
        employees: selectedData.map((emp) => ({
          emp_id: emp.emp_id, // backend expects emp_id
          premium: emp.premium || 0,
          gst: emp.emp_gst || 0,
          total_premium: emp.total_premium || 0,
        })),
        totals: {
          premium: totalPremium,
          gst1: totalGST,
          total_premium: totalWithGST,
        },
      };

      console.log("Saving Selected Employees Payload:", payload);

      // 🔹 Send to backend
      const res = await fetch("/api/scheme/updateSelectedEmployees", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data.success) {
        alert("✅ Employee & Scheme premiums updated successfully!");
        setShowEmployeePopup(false);
      } else {
        alert("❌ Failed to update employees. Please try again.");
      }
    } catch (err) {
      console.error("Error saving selected employees:", err);
      alert("⚠️ Something went wrong while saving employee premiums.");
    }
  };

  const handleSendMail = async () => {
    if (!file || !selectedCompany) {
      alert("Please select an insurer and attach the Excel file before sending.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("insurer_name", selectedCompany.insurer_name);
    formData.append("insurer_email", selectedCompany.insurer_email);

    setLoading(true);
    try {
      const res = await fetch("/api/sendMailToInsurer", {
        method: "POST",
        body: formData,
      });
      const result = await res.json();
      if (result.success) {
        alert("Mail sent successfully to the insurer!");
        setShowMailPopup(false);
        setShowNotification(false);
        setFile(null);
        setSelectedCompany(null);
      } else {
        alert("Failed to send mail. Please try again.");
      }
    } catch (err) {
      console.error("Mail send error:", err);
      alert("Error sending mail. Please check console for details.");
    } finally {
      setLoading(false);
    }
  };


  const handleDuplicate = async (scheme) => {
    try {
      // 1. Get base name
      let baseName = scheme.scheme_name;

      // 2. Fetch matching names from server
      const res = await fetch(
        `/api/schemes/check-duplicates?name=${encodeURIComponent(baseName)}`
      );
      const data = await res.json();

      let newName = baseName;

      // 3. If duplicates exist -> apply Copy, Copy 1, Copy 2...
      if (data.count > 0) {
        newName = `${baseName} (Copy ${data.count})`;
      } else {
        newName = `${baseName} (Copy)`;
      }

      // 4. Prepare FormData for API
      const formData = new FormData();
      formData.append("cat_id", scheme.cat_id);
      formData.append("org_id", localStorage.getItem("org_id"));
      formData.append("policy_type_id", scheme.policy_type_id || "");
      formData.append("policy_id", scheme.policy_id || "");
      formData.append("policy_name", scheme.policy_name || "");
      formData.append("policy_number", scheme.policy_number || "");
      formData.append("insurer", scheme.insurer || "");
      formData.append("tpa", scheme.tpa || "");
      formData.append("gst", scheme.gst || "");
      formData.append("start_date", scheme.start_date || "");
      formData.append("end_date", scheme.end_date || "");
      formData.append("scheme_name", newName);
      formData.append("family_spouse", scheme.family_spouse);
      formData.append("family_child", scheme.family_child);
      formData.append("no_of_children", scheme.no_of_children);
      formData.append("family_parents", scheme.family_parents);
      formData.append("family_inlaws", scheme.family_inlaws);
      formData.append("premium", 0);          // or ""
      formData.append("gst1", 0);              // or ""
      formData.append("total_premium", 0);
      formData.append("sum_insured", scheme.sum_insured);
      if (scheme.scheme_doc) {
        formData.append("scheme_doc_existing", scheme.scheme_doc);
      }
      const response = await fetch("/api/setup/addScheme", {
        method: "POST",
        body: formData,
      });
      const result = await response.json();
      if (result.success) {
        alert("Scheme duplicated successfully!");
        fetchSchemes();
      } else {
        alert("Duplicate failed!");
      }
    } catch (err) {
      console.error("Error duplicating scheme:", err);
      alert("Error duplicating scheme. Check console.");
    }
  };


  return (
    <div className="scheme-page">
      <aside className="sidebar">
        <Header />
      </aside>
      <main className="main-content">

        <div className="header">
          <h2>Scheme List</h2>
          <div className="header-right">
            {status === "pending" && (
              <button className="add-member-btn pending" disabled>
                Pending Approval
              </button>
            )}

            {status === "approved" && (
              <button
                className="add-member-btn"
                onClick={() => navigate("/add-new")}
              >
                Add New Employees
              </button>
            )}
            <button className="add-btns green" onClick={handleAddSchemeClick}>
              Add Scheme
            </button>
          </div>
        </div>

        {/* Table */}
        <div className="scheme-section card">
          <h4>Scheme Table (Filter by Category)</h4>

          <div className="search-filter-container">
            <div className="search-box">
              <FaSearch className="search-icon" />
              <input
                type="text"
                placeholder="Search Scheme Name..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
              />
            </div>

            {/* Category Filter */}
            <div className="category-box">
              <label>Select Category:</label>
              <FaFilter className="filter-icon" />
              <select
  value={filterCategory}
  onChange={(e) => {
    const id = e.target.value;
    setFilterCategory(id);
    handleCategoryChange(id);
  }}
>
  <option value="">-- Select Category --</option>

  {Array.isArray(categories) &&
    categories.map((cat) => (
      <option key={cat.cat_id} value={cat.cat_id?.toString()}>
        {cat.cat_org_custom_name}
      </option>
    ))}
</select>
            </div>
          </div>

          {loadingSchemes ? (
            <p>Loading schemes...</p>
          ) : schemeList.length > 0 ? (
            <div className="scheme-table-container">
              <table className="scheme-table">
                <thead>
                  <tr>
                 <th>Category</th>
                    <th>Scheme Name</th>
                    
                    <th>Policy Number</th>
                    <th>Scheme Doc</th>
                    <th>Insurer</th>
                    <th>TPA</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Family Definaton</th>
                    <th>Sum Insured</th>
                    <th>GST</th>
                    <th>Premium</th>
                    <th>Total Premium</th>
                    <th>Action</th>
                  </tr>
                </thead>

                  <tbody>
                    {[
                      ...new Map(
                        schemeList
                          .filter((s) => {
                            const nameMatch =
                              s.scheme_name?.toLowerCase().includes(searchTerm.toLowerCase());

                            const categoryMatch = filterCategory
                              ? s.cat_id?.toString() === filterCategory.toString()
                              : true;


                            return nameMatch && categoryMatch;
                          })
                          .map((item) => [item.scheme_id, item])
                      ).values(),
                    ].map((scheme, index) => (
                     <tr key={scheme.scheme_id}>
                       <td>{scheme.cat_org_custom_name}</td>
                        <td>
                          {scheme.scheme_name
                            ? scheme.scheme_name.split("(")[0].trim() // take text before first "("
                            : ""}
                        </td>                   
                        <td>{scheme.policy_number}</td>
                        <td>
                          {scheme.scheme_doc ? (
                            <a
                              href={`/uploads/${scheme.scheme_doc}`} // remove /schemes
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              View
                            </a>

                          ) : (
                            "-"
                          )}
                        </td>
                        <td>{scheme.insurer}</td>
                        <td>{scheme.tpa}</td>
                        <td>{scheme.start_date ? scheme.start_date.split("T")[0] : ""}</td>
                        <td>{scheme.end_date ? scheme.end_date.split("T")[0] : ""}</td>
                        <td>
                          {scheme.family_spouse || scheme.family_child || scheme.family_parents || scheme.family_inlaws ? (
                            <>
                              {scheme.family_spouse ? "Spouse " : ""}
                              {scheme.family_child ? `Child (${scheme.no_of_children}) ` : ""}
                              {scheme.family_parents ? "Parents " : ""}
                              {scheme.family_inlaws ? "In-LawsParents" : ""}
                            </>
                          ) : (
                            "Employees"
                          )}
                        </td>
                        <td>{scheme.sum_insured}</td>
                        <td>{scheme.gst}</td>
                        <td>{scheme.premium}</td>
                        <td>{scheme.total_premium}</td>
                        <td className="schemeaction-buttons">
                          <button
                            onClick={() => {
                              const selectedScheme = {
                                scheme_id: scheme.scheme_id,
                                scheme_name: scheme.scheme_name,
                                policy_id: scheme.policy_id,
                                sum_insured:
                                  scheme.sum_insured ||
                                  scheme.scheme_sum_insured ||
                                  scheme.suminsured ||
                                  0,
                                gst: scheme.gst || scheme.gst_percent || 0,
                                family_spouse: scheme.family_spouse,
                                family_child: scheme.family_child,
                                no_of_children: scheme.no_of_children,
                                family_parents: scheme.family_parents,
                                family_inlaws: scheme.family_inlaws,
                                cat_id: scheme.cat_id, // <-- add this
                                cat_org_custom_name: scheme.cat_org_custom_name,
                              };

                              console.log(
                                "📝 Adding employees for scheme:",
                                selectedScheme
                              );
                              handleAddEmployeesToScheme(selectedScheme);
                            }}
                            className="schemeicon"
                            title="Add Employees"
                          >
                            <FaPlus />
                          </button>

                            <button
                              onClick={() => handleView(scheme)}
                              className="schemeicon"
                              title="View"
                            >
                              <FaEye />
                            </button>
                            <button
                              onClick={() => handleEdit(scheme)}
                              className="schemeicon"
                              title="Edit"
                            >
                              <FaEdit />
                            </button>
                          <button
                            onClick={() => handleDelete(scheme.scheme_id)}
                            className="schemeicon"
                            title="Delete"
                          >
                            <FaTrash />
                          </button>
                          <button
                            className="view-employees-btn"
                            onClick={() => handleViewEmployees(scheme.scheme_id, scheme.cat_id)}
                            title="View Employees"
                          >
                            View Employees
                          </button>
                          <button
                            onClick={() => handleDuplicate(scheme)}
                            className="schemeicon"
                            title="Duplicate Scheme"
                          >
                            <FaCopy />
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p>No schemes found for this category.</p>
          )}
        </div>
      </main>

      {showEmployeePopup && (
        <div className="schemeEmployeeSelect-overlay">
          <div className="schemeEmployeeSelect card">
            <div className="popup-header">
              <h3>
                Select Employees for Scheme: {selectedScheme?.scheme_name || selectedScheme?.scheme_id}
              </h3>
              <button
                className="close-btn"
                onClick={() => setShowEmployeePopup(false)}
                aria-label="Close"
              >
                <FaTimes />
              </button>

            </div>
            <div className="employee-table-wrapper">

              {/* Employee Table */}
              <table>
                <thead>
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        className="blue-checkbox"
                        checked={
                          selectedEmployees.length === filteredEmployees.length &&
                          filteredEmployees.length > 0
                        }
                       
                      />
                    </th>
                    <th>Categories</th>
                    <th>EMP ID</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Designation</th>
                    <th>DOB</th>
                    <th>Age</th>
                    <th>Spouse</th>
                    <th>Spouse DOB</th>
                    <th>Children Names</th>
                    <th>Children DOBs</th>
                    <th>Parents</th>
                    <th>Parents DOBs</th>
                    <th>In-Laws</th>
                    <th>In-Laws DOBs</th>
                    <th>Joining Date</th>
                    <th>Premium</th>
                    <th>GST</th>
                    <th>Total Premium</th>
                  </tr>
                </thead>

                <tbody>
                  {loadingEmployeeList ? (
                    <tr>
                      <td colSpan="20">Loading...</td>
                    </tr>
                  ) : currentEmployees.length > 0 ? (
                    filteredEmployees.map((emp) => {

                      const childDobs = Array.isArray(emp.child_dob)
                        ? emp.child_dob
                        : emp.child_dob
                          ? [emp.child_dob]
                          : [];

                      const childNames = childDobs.map((_, i) => {
                        if (i === 0) return emp.child_name || "";
                        if (i === 1) return emp.child2_name || "";
                        if (i === 2) return emp.child3_name || "";
                        return "";
                      });

                      const parentNames = [emp.father_name, emp.mother_name].filter(Boolean);
                      const parentDobs = [emp.father_dob, emp.mother_dob]
                        .filter(Boolean)
                        .map((d) => (typeof d === "string" ? d.split("T")[0] : d));

                      const inlawNames = [emp.father_inlaw_name, emp.mother_inlaw_name].filter(Boolean);
                      const inlawDobs = [emp.father_inlaw_dob, emp.mother_inlaw_dob]
                        .filter(Boolean)
                        .map((d) => (typeof d === "string" ? d.split("T")[0] : d));

                      return (
                        <tr key={emp.id}>
                          <td>
                            <input
                              type="checkbox"
                              className="blue-checkbox locked-checkbox"
                              checked={selectedEmployees.includes(emp.id)}
                              onChange={(e) => {
                                e.preventDefault();   // ⛔ stop default toggle
                                return;               // ⛔ stop state change
                              }}
                            />
                          </td>

                          <td>{emp.cat_org_custom_name}</td>
                          <td>{emp.emp_id}</td>
                          <td>{emp.emp_name}</td>
                          <td>{emp.emp_email_id}</td>
                          <td>{emp.designation}</td>
                          <td>{emp.dob ? emp.dob.split("T")[0] : ""}</td>
                          <td>{emp.age}</td>
                          <td>{emp.spouse_name || ""}</td>
                          <td>{emp.spouse_dob ? emp.spouse_dob.split("T")[0] : ""}</td>
                          <td>{childNames.join(", ")}</td>
                          <td>
                            {childDobs
                              .map((d) => {
                                if (!d) return "";
                                const date = new Date(d);
                                return isNaN(date) ? d : date.toISOString().split("T")[0];
                              })
                              .join(", ")}
                          </td>
                          <td>{parentNames.join(", ")}</td>
                          <td>{parentDobs.join(", ")}</td>
                          <td>{inlawNames.join(", ")}</td>
                          <td>{inlawDobs.join(", ")}</td>
                          <td>{emp.joining_date ? emp.joining_date.split("T")[0] : ""}</td>
                          <td>{emp.premium || ""}</td>
                          <td>{emp.emp_gst || ""}</td>
                          <td>{emp.total_premium || ""}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="20">No employees found for this scheme category</td>
                    </tr>
                  )}
                </tbody>
              </table>

            </div>

            {/* Summary Section */}
            {(() => {
              const selectedData = filteredEmployees.filter((e) =>
                selectedEmployees.includes(e.id)
              );

              const totalPremium = selectedData.reduce(
                (sum, e) => sum + (parseFloat(e.premium) || 0),
                0
              );
              const totalGst = selectedData.reduce(
                (sum, e) => sum + (parseFloat(e.emp_gst) || 0),
                0
              );
              const grandTotal = selectedData.reduce(
                (sum, e) => sum + (parseFloat(e.total_premium) || 0),
                0
              );

              return (
                <div className="summary-section" style={{ marginTop: "15px" }}>
                  <label>
                    Premium of Selected Employees:
                    <input type="text" readOnly value={totalPremium ? totalPremium.toFixed(2) : ""} />
                  </label>
                  <br />
                  <label>
                    GST of Selected Employees:
                    <input type="text" readOnly value={totalGst ? totalGst.toFixed(2) : ""} />
                  </label>
                  <br />
                  <label>
                    Total Premium of Employees:
                    <input type="text" readOnly value={grandTotal ? grandTotal.toFixed(2) : ""} />
                  </label>
                </div>
              );
            })()}

            <div className="popup-actions">
              <button className="save-btn" onClick={handleSaveSelectedEmployees}>
                💾 Save Selected Employees
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Popup */}
      {showPopup && (
        <div className="scheme-popup-overlay">
          <div className="schemepopup">
            <div className="schemepopup-header">
              <h3>
                {isViewing ? "View Scheme" : isEditing ? "Edit Scheme" : "Add Scheme"}
              </h3>

              <button className="schemeclose-btn" onClick={() => setShowPopup(false)}>
                &times;
              </button>
            </div>
            <form onSubmit={handleSubmit} className="popup-form">
              <div className="form-grid">
                <label>
                  Category:
                  <select
                    value={popupCategory}
                    required
                    disabled={isViewing}
                    onChange={(e) => {
                      if (isViewing) return;

                      const id = e.target.value;

                      setPopupCategory(id);
                      setNewScheme((prev) => ({
                        ...prev,
                        cat_id: id,
                        policyId: "",        // reset policy on category change
                      }));

                      fetchSchemesByCategory(id);
                    }}
                  >
                    <option value="">-- Select Category --</option>
                    {categories.map((cat) => (
                      <option key={cat.cat_id} value={cat.cat_id}>
                        {cat.cat_org_custom_name}
                      </option>
                    ))}
                  </select>
                </label>

                <label>
                  Policy Type:
                  <select name="policyType" onChange={handleChange} value={newScheme.policyType}>
                    <option value="">Select</option>
                    
                    {policyTypes.map((pt) => (
                      <option key={pt.policy_id} value={pt.policy_id}>
                        {pt.policy_type}
                      </option>
                    ))}
                  </select>
                </label>

                <label>
                  Policy Name:
                  <select
                    name="policyId"
                    onChange={handleChange}
                    value={newScheme.policyId || ""}
                    disabled={isViewing}
                  >
                    <option value="">Select</option>
                    {filteredPolicies.map((p) => (
                      <option key={p.policy_id} value={p.policy_id}>
                        {p.policy_name}
                      </option>
                    ))}
                    {isEditing &&
                      newScheme.policyId &&
                      !filteredPolicies.some((p) => p.policy_id === newScheme.policyId) && (
                        <option value={newScheme.policyId}>{newScheme.policyName}</option>
                      )}
                  </select>
                </label>
                <label>
                  Policy Number:
                  <input name="policyNumber" value={newScheme.policyNumber} readOnly />
                </label>

                <label>
                  Insurer:
                  <input name="insurer" value={newScheme.insurer} readOnly />
                </label>

                <label>
                  TPA:
                  <input name="tpa" value={newScheme.tpa} readOnly />
                </label>

                <label>
                  Scheme Name:
                  <input
                    type="text"
                    readOnly={isViewing}
                    maxLength={20}
                    value={newScheme.schemeName || ""}
                    onChange={(e) => {
                      const value = e.target.value;

                      // ❌ only numbers not allowed
                      if (/^\d+$/.test(value)) {
                        setSchemeError("Scheme name cannot contain only numbers");
                      } else {
                        setSchemeError("");
                      }

                      setNewScheme({
                        ...newScheme,
                        schemeName: value
                      });
                    }}
                    style={{
                      borderColor: schemeError ? "red" : ""
                    }}
                  />

                  {schemeError && (
                    <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                      {schemeError}
                    </div>
                  )}
                </label>
                <label>
                  GST%:
                  <input name="gst" value={newScheme.gst} readOnly />
                </label>
                <label>
                  Start Date:
                  <input
                    type="date"
                    name="startDate"
                    value={newScheme.startDate || ""}
                    readOnly
                  />
                </label>
                <label>
                  End Date:
                  <input
                    type="date"
                    name="endDate"
                    value={newScheme.endDate || ""}
                    readOnly
                  />
                </label>
                <label>
                  Upload Scheme Doc:
                  <input
                    type="file"
                    required={!isEditing}
                    onChange={(e) =>
                      setNewScheme({ ...newScheme, scheme_doc: e.target.files[0] })
                    }
                  />
                </label>
                <label>
                  Sum Insured:
                  {isViewing ? (
                    // 👁 VIEW MODE → READ ONLY
                    <input
                      type="text"
                      className="addpolicy-input"
                      value={
                        selectedSumInsured
                          ? `₹ ${Number(selectedSumInsured).toLocaleString()}`
                          : ""
                      }
                      readOnly
                    />
                  ) : (
                    // ✏️ ADD / EDIT MODE → DROPDOWN
                    <select
                      value={selectedSumInsured || ""}
                      required={!isEditing}
                      onChange={(e) => {
                        const value = e.target.value;
                        setSelectedSumInsured(value);
                        setNewScheme((prev) => ({
                          ...prev,
                          sum_insured: value,
                        }));
                      }}
                      disabled={!premiumRates.length}
                    >
                      <option value="">-- Select Sum Insured --</option>
                      {[...new Set(premiumRates.map((r) => r.sum_insured))].map((amount, i) => (
                        <option key={i} value={amount}>
                          ₹ {Number(amount).toLocaleString()}
                        </option>
                      ))}
                    </select>
                  )}
                </label>
                {/* Family Definition */}
                <div className="family-def">
                  Family Definition:

                  <label>
                    <input
                      type="checkbox"
                      value="Spouse"
                      onChange={handleCheckbox}
                      checked={newScheme.familyDefinition?.includes("Spouse")}
                    />
                    Spouse
                  </label>

                  <label>
                    <input
                      type="checkbox"
                      value="Child"
                      onChange={handleCheckbox}
                      checked={newScheme.familyDefinition?.includes("Child")}
                    />
                    Child
                  </label>
                  <label>
                    <input
                      type="checkbox"
                      value="Parents"
                      onChange={handleCheckbox}
                      checked={newScheme.familyDefinition?.includes("Parents")}
                    />
                    Parents
                  </label>
                  <label>
                    <input
                      type="checkbox"
                      value="In-LawsParents"
                      onChange={handleCheckbox}
                      checked={newScheme.familyDefinition?.includes("In-LawsParents")}
                    />
                    In-Laws Parents
                  </label>
                  {/* ✅ Show "No. of Children" only when Child is selected */}
                  {newScheme.familyDefinition?.includes("Child") && (
                    <div className="child-count">
                      <label>
                        No. of Children:
                        <input
                          type="number"
                          readOnly={isViewing}
                          name="no_of_children"
                          value={newScheme.no_of_children || ""}
                          min="1"
                          max="3"
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value === "") {
                              setNewScheme((prev) => ({ ...prev, no_of_children: "" }));
                              return;
                            }
                            const num = parseInt(value, 10);
                            if (num >= 1 && num <= 3) {
                              setNewScheme((prev) => ({ ...prev, no_of_children: num }));
                            } else {
                              alert("Number of children must be 1, 2, or 3 only.");
                            }
                          }}
                        />
                      </label>
                    </div>
                  )}
                </div>
                <br></br>
                <br></br>
              </div>

              <div className="popup-actions">
                {!isViewing && (  // ✅ only show when NOT in view mode
                  <button type="submit" className="submit-btn">
                    {isEditing ? "Update Scheme" : "Add Scheme"}
                  </button>
                )}
              </div>

            </form>
          </div>
        </div>
      )}

      {showChoicePopup && (
        <div className="scheme-choice-overlay">
          <div className="scheme-choice-box">
            <button className="choice-close-icon" onClick={() => setShowChoicePopup(false)}>
              &times;
            </button>

            <h4>Create scheme</h4>
            <p>Do you want to create a scheme with insurance  or without insurer?</p>

            <div className="choice-actions">
              <button className="btn blue" onClick={chooseWithInsurer}>
                With insurer
              </button>

              <button className="btn gray" onClick={chooseWithoutInsurer}>
                Without Insurer
              </button>
            </div>
          </div>
        </div>
      )}
     {showWithoutInsurerPopup && (
  <div className="scheme-popup-overlay">
    <div className="schemepopup">
      <div className="schemepopup-header">
        <h3>{isEditing ? "Edit Scheme" : "Create Scheme — Without Insurer"}</h3>
        <button className="schemeclose-btn" onClick={() => setShowWithoutInsurerPopup(false)}>
          &times;
        </button>
      </div>

      <form onSubmit={handleSaveWithoutInsurer} className="popup-form">
        <div className="form-grid">

          {/* CATEGORY */}
          <label>
            Category:
            <select
              value={newSchemeWithout.cat_id || ""}
              required
              onChange={(e) =>
                setNewSchemeWithout((p) => ({ ...p, cat_id: e.target.value }))
              }
            >
              <option value="">-- Select Category --</option>
              {categories.map((cat) => (
                <option key={cat.cat_id} value={cat.cat_id}>
                  {cat.cat_org_custom_name}
                </option>
              ))}
            </select>
          </label>

          <label>
            Scheme Name:
            <input
              value={newSchemeWithout.schemeName}
              onChange={(e) =>
                setNewSchemeWithout((p) => ({ ...p, schemeName: e.target.value }))
              }
              required
            />
          </label>

          <label>
            Start Date:
            <input
              type="date"
              value={newSchemeWithout.startDate}
              onChange={(e) =>
                setNewSchemeWithout((p) => ({ ...p, startDate: e.target.value }))
              }
              required
            />
          </label>

          <label>
            End Date:
            <input
              type="date"
              value={newSchemeWithout.endDate}
              onChange={(e) =>
                setNewSchemeWithout((p) => ({ ...p, endDate: e.target.value }))
              }
              required
            />
          </label>

          <label>
            Upload Doc:
            <input
              type="file"
              onChange={(e) =>
                setNewSchemeWithout((p) => ({ ...p, schemeDoc: e.target.files[0] }))
              }
            />
          </label>

          {/* FAMILY */}
          <div className="family-def">
            <div>Family Definition:</div>

            {["Spouse", "Child", "Parents", "In-LawsParents"].map((item) => (
              <label key={item}>
                <input
                  type="checkbox"
                  checked={newSchemeWithout.familyDefinition.includes(item)}
                  onChange={() => toggleFamilyWithout(item)}
                />
                {item}
              </label>
            ))}

            {newSchemeWithout.familyDefinition.includes("Child") && (
              <label>
                No. of Children:
                <input
                  type="number"
                  min="1"
                  max="3"
                  value={newSchemeWithout.noOfChildren}
                  onChange={(e) =>
                    setNewSchemeWithout((p) => ({
                      ...p,
                      noOfChildren: e.target.value,
                    }))
                  }
                />
              </label>
            )}
          </div>

          <label>
            Premium:
            <input
              type="number"
              value={newSchemeWithout.premium || ""}
              onChange={(e) =>
                setNewSchemeWithout((p) => ({
                  ...p,
                  premium: e.target.value,
                }))
              }
            />
          </label>

          <label>
            GST %:
            <input
              type="number"
              value={newSchemeWithout.gst || ""}
              onChange={(e) =>
                setNewSchemeWithout((p) => ({
                  ...p,
                  gst: e.target.value,
                }))
              }
            />
          </label>

          <label>
            Total Premium:
            <input
              type="text"
              value={newSchemeWithout.totalPremium || ""}
              readOnly
            />
          </label>

        </div>

        <div className="popup-actions">
          <button type="submit" className="submit-btn">
            {isEditing ? "Update Scheme" : "Save Scheme"}
          </button>

          <button
            type="button"
            className="cancel-btn"
            onClick={() => setShowWithoutInsurerPopup(false)}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  </div>
)}
      {showNotification && (
        <div className="notification-overlay">
          <div className="notification-box">
            <h3>Add New Members</h3>
            <p>
              To add a new employee, you need to send an email notification to the insurer.
            </p>
            <div className="notification-actions">
              <button
                className="btn-notify"
                onClick={() => {
                  setShowMailPopup(true);
                  setShowNotification(false);
                }}
              >
                Send Mail
              </button>
              <button
                className="btn-cancel"
                onClick={() => setShowNotification(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Mail Popup */}
      {showMailPopup && (
        <div className="mail-overlay">
          <div className="mail-box">
            <h3>Send Mail to Insurer</h3>
            <p>Please attach the employee list Excel file for adding new members.</p>

            <div className="mail-form">
              <label>Insurer</label>
              <div className="mail-insurer-select">
                <select
                  value={selectedCompany ? selectedCompany.id : ""}
                  onChange={(e) =>
                    setSelectedCompany(
                      insuranceCompanies.find(
                        (c) => c.id === parseInt(e.target.value)
                      )
                    )
                  }
                >
                  <option value="">-- Select Insurer --</option>
                  {insuranceCompanies.map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.company_name}
                    </option>
                  ))}
                </select>

              </div>

              <label>Insurer Name</label>
              <input
                type="text"
                value={selectedCompany ? selectedCompany.insurer_name : ""}
                onChange={(e) =>
                  setSelectedCompany((prev) => ({
                    ...prev,
                    insurer_name: e.target.value,
                  }))
                }
              />

              <label>Insurer Email</label>
              <input
                type="email"
                value={selectedCompany ? selectedCompany.insurer_email : ""}
                onChange={(e) =>
                  setSelectedCompany((prev) => ({
                    ...prev,
                    insurer_email: e.target.value,
                  }))
                }
              />

              <label>Attach Employee Excel</label>
              <input
                type="file"
                accept=".xls,.xlsx"
                onChange={(e) => setFile(e.target.files[0])}
              />
            </div>

            <div className="mail-actions">
              <button
                className="btn-send"
                onClick={handleSendMail}
                disabled={loading}
              >
                {loading ? "Sending..." : "Send"}
              </button>
              <button
                className="btn-cancel"
                onClick={() => {
                  setShowMailPopup(false);
                  setFile(null);
                  setSelectedCompany(null);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {showEmployeesTable && (
        <div className="employee-popup-overlay">
          <div className="employee-popup-card">
            <button className="close-btn" onClick={() => setShowEmployeesTable(false)}>
              &times;
            </button>
            <h4>Employees for Selected Scheme: {selectedScheme?.scheme_name || "N/A"}</h4>
            <button className="download-pdf-btn" onClick={handleDownloadExcel}>
              <FaFileExcel style={{ marginRight: "5px" }} />
              Download Excel
            </button>
            <div ref={tableRef}>
            <table>
              <thead>
                <tr>
                  <th>Scheme ID</th>
                  <th>EMP ID</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Designation</th>
                  <th>Joining Date</th>
                  <th>DOB</th>
                  <th>Age</th>
                  <th>Category</th>
                  <th>Premium</th>
                  <th>GST</th>
                  <th>Total Premium</th>
                </tr>
              </thead>
              <tbody>
                {viewSchemeEmployees.length > 0 ? (
                  viewSchemeEmployees.map((emp) => (
                    <tr key={emp.emp_id}>
                      <td>{emp.scheme_id}</td>
                      <td>{emp.emp_id}</td>
                      <td>{emp.emp_name}</td>
                      <td>{emp.emp_email_id}</td>
                      <td>{emp.designation}</td>
                      <td>{emp.joining_date?.split("T")[0]}</td>
                      <td>{emp.dob?.split("T")[0]}</td>
                      <td>{emp.age}</td>
                      <td>{emp.cat_org_custom_name}</td>
                      <td>{emp.premium}</td>
                      <td>{emp.gst}</td>
                      <td>{emp.total_premium}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="12" style={{ textAlign: "center" }}>
                      No employees found for this scheme
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            </div>
          </div>
        </div>
      )}
      <Footer />

    </div>
  );
};

export default InitialSetup;
